/* tslint:disable */

export enum GuidelineChapterType {
  Text = 0,
  Conditions = 1,
  Criteria = 2,
  DiagnosisPlan = 3,
  Flowchart = 6,
  Workflow = 7,
}
